export const ORDERS_ENDPOINTS = {
  LIST: '/customer/orders/',
  DETAIL: (orderNumber: string) => `/customer/orders/${orderNumber}/`,
  TRACKING: (_orderNumber: string, shipmentNumber: string) => `/customer/orders/${shipmentNumber}/tracking/`,
} as const
